import { AavoDateTimePicker } from "src/components/common/inputFields/AavoDateTimePicker.tsx";
import { labelWithRequiredMark } from "src/components/views/erp/surveys/surveyUtils.ts";
import dayjs from "dayjs";
import { dayJsToLocalDateTimeIsoString } from "src/utils/dayjsUtils.ts";
import { SurveySubmissionFormFieldProps } from "src/components/views/erp/surveys/submissions/fields/SurveySubmissionFormField.tsx";

export const SurveySubmissionFormDateTimeField = ({
	field,
	value,
	onChange,
	error,
	disabled,
}: SurveySubmissionFormFieldProps) => {
	return (
		<AavoDateTimePicker
			label={labelWithRequiredMark(field)}
			value={value?.type === "dateTime" ? dayjs(value.value) : null}
			errorMessage={error}
			disabled={disabled}
			onChange={(value) => {
				if (value == null) onChange(null);
				else
					onChange({
						type: "dateTime",
						value: dayJsToLocalDateTimeIsoString(value),
					});
			}}
		/>
	);
};
